import { render, staticRenderFns } from "./ChangeCompanyModal.vue?vue&type=template&id=58472006&scoped=true&"
import script from "./ChangeCompanyModal.vue?vue&type=script&lang=js&"
export * from "./ChangeCompanyModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeCompanyModal.vue?vue&type=style&index=0&id=58472006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58472006",
  null
  
)

export default component.exports